import { generateUseContext } from '@guiker/react-utils'

import { SentryContext } from './SentryContext'

export const useSentryContext = generateUseContext(SentryContext)
